import React, { useState, useEffect } from "react";
import Select from "react-select";
import { privateRequest } from "../commonApi/CommonApi";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";

function ServiceshortCut() {
  const [Heading, setGroupName] = useState("");
  const [parentCategory, setParentCategoryGroups] = useState([]);
  const [gettservice, setGettService] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedGroupp, setSelectedGroupp] = useState();
  const [selectedGroup, setSelectedGroup] = useState();
  const [Status, setStatus] = useState("");
  const [serviceType, setServiceType] = useState("Service");
  const [editItemId, setEditItemId] = useState(null);
  const [selectedHeading, setSelectedHeading] = useState("");
  const [PCgroup, setPCgroup] = useState();
  const [services, setServices] = useState([]);
  const [shortcutHeadings, setShortcutHeadings] = useState([]);

  const getAllDocumentData = async () => {
    try {
      const response = await privateRequest.get(`Service/CombineApis`);
      // setCombineData(response?.data?.data);
      setPCgroup(response?.data?.data?.ParentGroup);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };
  const getShortcutHeadings = async () => {
    try {
      const response = await privateRequest.get(
        `ServiceShortcutHeading/GetShortcuteByStatus`
      );
      // setCombineData(response?.data?.data);
      setShortcutHeadings(response?.data?.data);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };

  const extractPCGroup = (item) => {
    // Package shortcut
    if (item?.Service?.PCgroup) {
      return item.Service.PCgroup;
    }
  
    // Service shortcut
    if (item?.Service?.ChildCatIDs?.PCName?.length) {
      return item.Service.ChildCatIDs.PCName[0].PCGroup;
    }
  
    return null;
  };
  

  useEffect(() => {
    getAllDocumentData();
    getShortcutHeadings();
  }, []);

  const getServices = async (selectedGroupId) => {
    try {
      let url = `Service/servicepackagebyPcgroup/` + selectedGroupId;
      const response = await privateRequest.get(url);

      setServices(response?.data?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleGroupChange = (selectedOption) => {
    const selectedGroupId = selectedOption.value;
    const selectedGroupLabel = selectedOption.label;

    setSelectedGroupp({
      label: selectedGroupLabel,
      value: selectedGroupId,
    });

    getServices(selectedGroupId);
  };
  const handleHeadingChange = (selectedOption) => {
    const selectedGroupId = selectedOption.value;
    const selectedGroupLabel = selectedOption.label;

    setSelectedHeading({
      label: selectedGroupLabel,
      value: selectedGroupId,
    });
  };

  const getServiceGroup = async () => {
    try {
      const response = await privateRequest.get(
        `ServiceShortcut/getShortcuteByStatus`
      );
      setGettService(response?.data?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getParentCategory = async () => {
    try {
      const response = await privateRequest.get(`Service/GetServices`);
      setParentCategoryGroups(response?.data?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const DeleteService = async (_id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        await privateRequest.delete(`ServiceShortcut/DeleteShortcute/${_id}`);
        getServiceGroup();
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire("Error!", "Failed to delete item.", "error");
    }
  };

  const AddServiceShortcut = async (event) => {
    event.preventDefault();
    try {
      const formData = {
        heading: Heading,
        Status: Status,
        serviceID: selectedGroup?.value,
        SectionId: selectedHeading?.value,
      };

      let responseMessage = "";

      if (editItemId) {
        await privateRequest.put(
          `ServiceShortcut/UpdateShortcut/${editItemId}`,
          formData
        );
        responseMessage = "updated";
      } else {
        await privateRequest.post(`ServiceShortcut/AddShortcute`, formData);
        responseMessage = "added";
      }
      getServiceGroup();
      setShowModal(false);
      setGroupName("");
      setSelectedGroup([]);
      setStatus("");
      setEditItemId(null);

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: `Service Shortcut ${responseMessage} successfully!`,
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.response.data.message,
      });
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    getServiceGroup();
    getParentCategory();
  }, []);

  const servicess = services.filter((item) => item.ServiceName !== undefined);
  const packages = services.filter((item) => item.packageTitle !== undefined);

  return (
    <>
      <style>{`
        #addHeroSliderModal .modal-dialog {
          border: none !important;
          outline: none !important;
        }
        #addHeroSliderModal .modal-content {
          border: none !important;
          outline: none !important;
        }
        @media (max-width: 768px) {
          #addHeroSliderModal .modal-dialog {
            width: 100% !important;
            padding: 0 !important;
            margin: 0 !important;
          }
          #addHeroSliderModal .modal-body {
            padding: 20px 15px !important;
          }
          #addHeroSliderModal .modal-header {
            padding: 15px 20px !important;
          }
        }
           /* Hide scrollbar (Chrome, Edge, Safari) */
          #addHeroSliderModal .modal-body::-webkit-scrollbar {
            width: 0px;
            display: none;
          }

          /* Hide scrollbar (Firefox) */
          #addHeroSliderModal .modal-body {
            scrollbar-width: none;
            -ms-overflow-style: none; /* IE 10+ */
          }
            .no-gutters {
            margin-right: 0;
            margin-left: 0;
          }
          .no-gutters > .col-md-6 {
            padding-left: 8px;
            padding-right: 8px;
          }
             #addHeroSliderModal .form-group {
            margin-bottom: 14px;
          }

          #addHeroSliderModal label {
            margin-bottom: 6px;
          }
      `}</style>
      {gettservice?.length > 0 && (
        <Helmet>
          <script>new DataTable("#my_table");</script>
        </Helmet>
      )}
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Service Shortcut</span>
                    </p>
                    <button
                      className="btn btn-primary btn-sm ml-auto"
                      onClick={() => {
                        setShowModal(true);
                        setSelectedGroupp("");
                        setGroupName("");
                        setStatus("");
                        setSelectedGroup(null);
                      }}
                    >
                      <i className="fa fa-plus mr-2"></i>Add New
                    </button>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card">
                    <div className="card-body table-responsive">
                      <table className="table table-striped table-hover table-sm">
                        <thead className="bg-primary text-white">
                          <tr>
                            <th scope="col">Sr No</th>
                            <th scope="col">Heading</th>
                            <th scope="col">ServiceId</th>
                            <th scope="col">Status</th>
                            <th scope="col">Created</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {gettservice?.map((item, index) => (
                            <tr key={index}>
                              <td className="align-center">{index + 1}</td>
                              <td className="align-center">
                                {item?.SectionId?.Heading}
                              </td>
                              <td className="align-center">
                                {item?.Service?.packageTitle
                                  ? item.Service.packageTitle
                                  : item?.Service?.ServiceName
                                    ? `${item.Service.ServiceName} (${
                                        item.Service.ServiceVarients?.[0]?.ServiceType?.Name || ""
                                      })`
                                    : "—"}
                              </td>

                              <td>
                                <span
                                  className={`badge ${
                                    item?.Status.toString() === "true"
                                      ? "badge-primary"
                                      : "badge-danger"
                                  }`}
                                >
                                  {item?.Status.toString() === "true"
                                    ? "Active"
                                    : "Inactive"}
                                </span>
                              </td>
                              <td className="align-center">
                                <p className="mb-0">{item.CreatedBy?.name}</p>
                                <p className="mb-0">
                                  {new Date(item.createdAt).toLocaleDateString(
                                    "en-US",
                                    {
                                      day: "numeric",
                                      month: "long",
                                      year: "numeric",
                                    }
                                  )}
                                </p>
                              </td>
                              <td className="align-center">
                                <div className="btn-group">
                                  <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => {
                                      setEditItemId(item._id);
                                      setGroupName(item.heading);
                                      setStatus(item.Status ? "1" : "0");

                                      const isPackage = !!item?.Service?.packageTitle;
                                      setServiceType(isPackage ? "Package" : "Service");
                                      
                                    
                                      // ✅ 1. SET PARENT CATEGORY GROUP (THIS WAS MISSING)
                                      const pcGroup = extractPCGroup(item);
                                    
                                      if (pcGroup) {
                                        setSelectedGroupp({
                                          value: pcGroup._id,
                                          label: pcGroup.PCGName
                                        });
                                        // Load services for this parent category group
                                        getServices(pcGroup._id);
                                      } else {
                                        setSelectedGroupp(null);
                                      }
                                    
                                      // ✅ 2. SET SERVICE (VARIANT ID)
                                      setSelectedGroup({
                                        value: item.serviceID,
                                        label: isPackage
                                          ? item?.Service?.packageTitle
                                          : item?.Service?.ServiceName +
                                            " (" +
                                            item?.Service?.ServiceVarients?.[0]?.ServiceType?.Name +
                                            ")",
                                      });
                                    
                                      // ✅ 3. SET HEADING
                                      setSelectedHeading({
                                        label: item?.SectionId?.Heading,
                                        value: item?.SectionId?._id,
                                      });
                                    
                                      setShowModal(true);
                                    }}
                                    
                                    data-toggle="modal"
                                    data-target="#addAreaModal"
                                  >
                                    <i className="fa fa-edit"></i>
                                  </button>

                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => DeleteService(item._id)}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* All Modals */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="addHeroSliderModal"
        tabIndex="-1"
        role="dialog"
        style={{ 
          display: showModal ? "flex" : "none",
          alignItems: "center",
          justifyContent: "center",
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100vh",
          zIndex: 1050,
          margin: 0,
          padding: 0
        }}
      >
        <div 
          className="modal-dialog modal-dialog-centered" 
          role="document"
          style={{
            maxWidth: "520px",
            width: "90%",
            margin: 0,
            padding: 0
          }}
        >
          <div className="modal-content" style={{ 
            borderRadius: "15px", 
            boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
            border: "none",
            margin: 0,
            outline: "none"
          }}>
            <div className="modal-header" style={{ 
              borderBottom: "2px solid #f0f0f0",
              padding: "20px 25px",
              borderRadius: "15px 15px 0 0",
              backgroundColor: "#f8f9fa",
              borderTop: "none",
              borderLeft: "none",
              borderRight: "none",
              margin: 0
            }}>
              <h5 className="modal-title" id="exampleModalLongTitle" style={{ 
                fontSize: "20px",
                fontWeight: "600",
                color: "#333",
                margin: 0
              }}>
                {editItemId ? "Edit Service Shortcut" : "Add Service Shortcut"}
              </h5>
              <button
                type="button"
                className="close"
                onClick={() => {
                  setShowModal(false);
                  setGroupName("");
                  setSelectedGroup(null);
                  setSelectedHeading("");
                  setSelectedGroupp(null);
                  setEditItemId(null);
                  setStatus("");
                }}
                aria-label="Close"
                style={{
                  fontSize: "28px",
                  fontWeight: "300",
                  color: "#999",
                  opacity: 0.7,
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: "0",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: 0
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.color = "#333";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "0.7";
                  e.target.style.color = "#999";
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ 
              padding: "18px 20px",

              maxHeight: "calc(100vh - 200px)",
              overflowY: "auto",
              margin: 0
            }}>
              <form onSubmit={AddServiceShortcut}>
                <div className="row no-gutters">
                  <div className="form-group col-md-6 mb-3">
                    <label style={{ 
                      fontWeight: "500",
                      marginBottom: "8px",
                      color: "#555",
                      fontSize: "14px"
                    }}>
                      Heading <span style={{ color: "#dc3545" }}>*</span>
                    </label>
                    <Select
                      options={shortcutHeadings?.map((group) => ({
                        value: group._id,
                        label: group.Heading,
                      }))}
                      onChange={handleHeadingChange}
                      value={selectedHeading}
                      isMulti={false}
                      isClearable
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: "38px",
                          borderColor: "#ddd",
                          "&:hover": {
                            borderColor: "#006eb6"
                          }
                        })
                      }}
                    />
                  </div>
                  <div className="form-group col-md-6 mb-3">
                    <label style={{ 
                      fontWeight: "500",
                      marginBottom: "8px",
                      color: "#555",
                      fontSize: "14px"
                    }}>
                      Parent Category Group <span style={{ color: "#dc3545" }}>*</span>
                    </label>
                    <Select
                      isClearable
                      options={PCgroup?.map((group) => ({
                        value: group._id,
                        label: group.PCGName,
                      }))}
                      onChange={handleGroupChange}
                      value={selectedGroupp}
                      isMulti={false}
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: "38px",
                          borderColor: "#ddd",
                          "&:hover": {
                            borderColor: "#006eb6"
                          }
                        })
                      }}
                    />
                  </div>
                </div>
                <div className="form-group mb-3">
                  <label style={{ 
                    fontWeight: "500",
                    marginBottom: "8px",
                    color: "#555",
                    fontSize: "14px"
                  }}>
                    Service/Package <span style={{ color: "#dc3545" }}>*</span>
                  </label>
                  <select
                    className="form-control"
                    value={serviceType}
                    onChange={(e) => setServiceType(e.target.value)}
                    style={{
                      height: "38px",
                      borderColor: "#ddd",
                      fontSize: "14px"
                    }}
                  >
                    <option value="">Select Type</option>
                    <option value="Service">Service</option>
                    <option value="Package">Package</option>
                  </select>
                </div>
                <div className="form-group mb-3">
                  <label style={{ 
                    fontWeight: "500",
                    marginBottom: "8px",
                    color: "#555",
                    fontSize: "14px"
                  }}>
                    Service/Package Selection <span style={{ color: "#dc3545" }}>*</span>
                  </label>
                  <Select
                    isClearable
                    options={
                      serviceType === "Service"
                        ? servicess.map((group) => {
                            let serviceName = "";

                            if (
                              group.ServiceVarients &&
                              group.ServiceVarients[0] &&
                              group.ServiceVarients[0].ServiceType
                            ) {
                              const serviceType =
                                group.ServiceVarients[0].ServiceType;
                              serviceName =
                                serviceType.Name !== "NA"
                                  ? `${group.ServiceName} - ${serviceType.Name}`
                                  : group.ChildCatIDs &&
                                    group.ChildCatIDs.CCName
                                  ? `${group.ServiceName} - ${group.ChildCatIDs.CCName}`
                                  : "Unknown Service";
                            }
                            let vall =
                              group.ServiceVarients &&
                              group.ServiceVarients[0] &&
                              group.ServiceVarients[0]._id;

                            return {
                              value: vall,
                              label: serviceName,
                            };
                          })
                        : packages.map((group) => ({
                            value: group._id,
                            label: group.packageTitle,
                          }))
                    }
                    onChange={(e) => {
                      setSelectedGroup(e);
                    }}
                    value={selectedGroup}
                    isMulti={false}
                    isDisabled={!serviceType}
                    placeholder={serviceType ? "Select service/package" : "Please select type first"}
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: "38px",
                        borderColor: "#ddd",
                        "&:hover": {
                          borderColor: "#006eb6"
                        }
                      })
                    }}
                  />
                </div>
                <div className="form-group mb-4">
                  <label style={{ 
                    fontWeight: "500",
                    marginBottom: "8px",
                    color: "#555",
                    fontSize: "14px"
                  }}>
                    Status <span style={{ color: "#dc3545" }}>*</span>
                  </label>
                  <select
                    className="form-control"
                    value={Status}
                    onChange={(e) => setStatus(e.target.value)}
                    style={{
                      height: "38px",
                      borderColor: "#ddd",
                      fontSize: "14px"
                    }}
                  >
                    <option value="">Select Status</option>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>

                <div className="form-group d-flex justify-content-end" style={{ marginTop: "10px", gap: "10px" }}>
                  <button 
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      setShowModal(false);
                      setGroupName("");
                      setSelectedGroup(null);
                      setSelectedHeading("");
                      setSelectedGroupp(null);
                      setEditItemId(null);
                      setStatus("");
                    }}
                    style={{
                      minWidth: "100px",
                      borderRadius: "8px",
                      padding: "8px 20px"
                    }}
                  >
                    Cancel
                  </button>
                  <button 
                    type="submit" 
                    className="btn btn-primary"
                    style={{
                      minWidth: "100px",
                      borderRadius: "8px",
                      padding: "8px 20px",
                      backgroundColor: "#006eb6",
                      borderColor: "#006eb6"
                    }}
                  >
                    {editItemId ? "Update" : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <div 
          className="modal-backdrop fade show"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1040,
            margin: 0,
            padding: 0,
            border: "none"
          }}
          onClick={() => {
            setShowModal(false);
            setGroupName("");
            setSelectedGroup(null);
            setSelectedHeading("");
            setSelectedGroupp(null);
            setEditItemId(null);
            setStatus("");
          }}
        ></div>
      )}
    </>
  );
}

export default ServiceshortCut;
